<!-- 客户管理-渠道 -->
<template>
  <div class="wrapper main-container">
    <div class="content">
      <div class="search-content" :class="{'open':searchMore}">
        <div class="input-item">
          <span class="label">姓名</span>
          <div class="value">
            <Input style="width:294px;" v-model="searchObj.name" placeholder="请输入姓名" clearable />
          </div>          
        </div>
        <div class="input-item">
          <span class="label">手机号</span>
          <div class="value">
            <Input
              style="width:280px;"
              v-model="searchObj.mobile"
              placeholder="请输入手机号"
              clearable
            />
          </div>
        </div>
        <div class="input-item">
          <span class="label">所属机构/团队</span>
          <div class="value">
            <selectTree @change="selectTreeChange" type="child" :isAll="true" ref="selectTree" style="width:243px;"></selectTree>
          </div>          
        </div>
        <div class="input-item">
          <span class="label">所属业务员</span>
          <div class="value">
            <Select clearable v-model="searchObj.agentId" style="width:256px;">
              <Option
                :value="item.id"
                v-for="(item, index) in salesmanList"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </div>
        </div>
        <div class="input-item">
          <span class="label">跟进状态</span>
          <div class="value">
            <Select clearable v-model="searchObj.followStatus" style="width:270px;">
              <Option
                :value="item.value"
                v-for="(item, index) in followUpStatusList"
                :key="index"
                >{{ item.txt }}</Option
              >
            </Select>
          </div>
        </div>

        <div class="input-item">
          <span class="label">客户来源</span>
          <div class="value">
            <Select clearable v-model="searchObj.source" style="width:268px;">
              <Option
                :value="item.code"
                v-for="(item, index) in sourceList"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </div>
        </div>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="queryList">搜索</Button>
        <Button class="reset-btn" @click="resetSearch">重置</Button>
        <Button class="reset-btn" v-if="searchMore" @click="searchMore = false"
          >收起<Icon type="ios-arrow-up"
        /></Button>
        <div class="close-open" v-else @click="searchMore = true">
          展开<Icon type="ios-arrow-down"/>
        </div>
      </div>
    </div>

    <div class="tabs-one">
      <div
        class="tab-pane"
        :class="item.value == searchObj.isSuccess ? 'tab-active' : ''"
        v-for="(item, index) in tabs"
        :key="index"
        @click="changeTabsOne(item.value, index)"
      >
        <a>{{ item.txt }}</a>
        <span class="tip-icon" v-if="index+1==tabs.length">?</span>
        <div class="pop-tip" v-if="index+1==tabs.length">
          <span>未成交：未出单的客户，可能存在无订单或多个订单。</span><br>
          <span>已成交：已投保成功的客户，包括出单后退保的客户。</span><br>
          <span>异议客户：入库客户已有业务员归属。</span><br>
          <span>预约客户：通过机构/业务员预约顾问链接获得的客户或机构额外提供的客户。支持管理者自行导入及分配所属业务员。</span><br>
          <span>自有客户：业务员自己的缘故客户，或转介绍客户，或静默成交自主投保的客户。支持业务员自行新增或导入。</span>
          <div class="arrow"></div>
        </div>
      </div>

      <div class="right">
        <Button class="import-btn" @click="$refs.importModal.open()">导入</Button>
        <Button class="export-btn" @click="$refs.exportValidation.open()">导出</Button>
      </div>
    </div>

    <div class="tabs-two" v-if="tabsOneActionIndex != 3">
      <div 
        class="tab-pane" 
        :class="item.value == searchObj.type?'active-tab':''" 
        v-for="(item, index) in tabsTwo"
        :key="index"
        @click="changeTabsTwo(item.value, index)"
      >
        <a>{{ item.txt }}</a>
      </div>
    </div>
    
    <template v-if="tabsOneActionIndex != 3">
      <statistics :data="statisticalData" :tabsOneActionIndex="tabsOneActionIndex" :tabsTwoActiveIndex="tabsTwoActiveIndex"></statistics>
    </template>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box setTable">      
      <Table :columns="columns" :data="tableDate">
        <template slot-scope="{ row }" slot="name">
          <a class="name" :class="{'red':!row.agentName}" @click="toDetail(row)">{{ row.name }}</a>
        </template>

        <template slot-scope="{ row }" slot="nameMobile">
          <div class="mobile">
            <a class="name" :class="{'red':!row.agentName}" @click="toDetail(row)">{{ row.name }}</a>
            <span style="margin:0 2px;">/</span>  
            <span v-if="row.eyeShow">{{ row.mobile }}</span>
            <span v-else>{{ row.mobile1 }}</span>
            <a v-show="row.mobile1">
              <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row)"></i>
              <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row)"></i>
            </a>
          </div>
        </template>

        <template slot-scope="{ row }" slot="mobile1">
          <div class="mobile">
            <span v-if="row.eyeShow">{{ row.mobile }}</span>
            <span v-else>{{ row.mobile1 }}</span>
            <a v-show="row.mobile1">
              <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row)"></i>
              <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row)"></i>
            </a>
          </div>
        </template>

        <template slot-scope="{ row }" slot="consulSuccessNum">
          <div class="consul-success-num">
            <span>{{ row.consulNum }}</span>
            <span class="line">/</span>
            <policy-number :row="row"></policy-number>
          </div>
        </template>

        <template slot-scope="{ row }" slot="successNum">
          <policy-number :row="row"></policy-number>
        </template>

        <template slot-scope="{ row }" slot="orderNum">
          <order-number :row="row"></order-number>
        </template>

        <template slot-scope="{ row }" slot="organizationName">
          <div class="agent-name" v-if="row.organizationName" @click="toOrgManage(row, 1)">
            <span class="agent-name-status" :style="{backgroundColor:row.orgStatus==0?'#E3461F':'#35BF3F'}"></span>
            <a class="agent-name no-border">{{ row.organizationName }}</a>
          </div> 
          <span v-else>-</span>         
        </template>

        <!-- 异议客户所属机构 -->
        <template slot-scope="{ row }" slot="orgName">
          <div class="agent-name" v-if="row.orgName" @click="toOrgManage(row, 1)">
            <span class="agent-name-status" :style="{backgroundColor:row.orgStatus==0?'#E3461F':'#35BF3F'}"></span>
            <a class="agent-name no-border">{{ row.orgName }}</a>
          </div> 
          <span v-else>-</span>         
        </template>

        <template slot-scope="{ row }" slot="groupName">
          <div class="agent-name" v-if="row.groupName" @click="toOrgManage(row, 2)">
            <a class="agent-name no-border">{{ row.groupName }}</a>
          </div>
          <span v-else>-</span>
        </template>

        <template slot-scope="{ row }" slot="agentName">
          <div class="user-box" v-if="row.agentName">
            <i class="dian" :class="{'red':row.agentStatus==0}"></i>
            <user-poptip :userName="row.agentName" :id="row.agentId"></user-poptip>
          </div>
          <span v-else class="no-user">暂无业务员</span>
        </template>

        <template slot-scope="{ row }" slot="agentAbnormalAgentName">
          <div class="abnormal">
            <div class="agent-name-abnormal" v-if="row.agentName">
              <i class="dian" :class="{'red':row.agentStatus==0}"></i>
              <user-poptip :userName="row.agentName" :id="row.agentId"></user-poptip>
            </div>
            <span v-else>-</span>
            <span class="line">/</span>
            <div class="agent-name-abnormal">
              <i class="dian" :class="{'red':row.abnormalAgentStatus==0}"></i>
              <user-poptip :userName="row.abnormalAgentName" :id="row.abnormalAgentId"></user-poptip>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="finalBelongAgentName">
          <div class="user-box" v-if="row.finalBelongAgentName">
            <i class="dian" :class="{'red':row.finalBelongAgentStatus==0}"></i>
            <user-poptip :userName="row.finalBelongAgentName" :id="row.finalBelongAgent"></user-poptip>
          </div>
          <span v-else>-</span>
        </template>

        <template slot-scope="{ row }" slot="bar">
          <div class="action">
            <span v-if="tabsOneActionIndex!=3">
              <a v-if="row.agentId" @click="$refs.reassign.open(row)">重新分配</a>
              <a v-else @click="$refs.distribution.open(row)">分配</a>
            </span>
            <span v-else>
              <a @click="$refs.distributionAbnormal.open(row, true)" v-if="!row.finalBelongAgentName">分配</a>
              <a @click="$refs.distributionAbnormal.open(row, false)" v-else>重新分配</a>
            </span>             
          </div>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page
        :total="total"
        :current="searchObj.pageNo"
        :page-size="searchObj.pageSize"
        show-total
        @on-change="pageChange"
        style="text-align: center;"
      />
    </div>

    <!-- 批量导入客户 -->
    <import-modal ref="importModal" :getInsureList="getInsureList"></import-modal>

    <!-- 分配 -->
    <distribution ref="distribution" :getInsureList="getInsureList"></distribution>

    <!-- 异常分配 -->
    <distribution-abnormal ref="distributionAbnormal" :getInsureList="getObjectionList"></distribution-abnormal>

    <!-- 重新分配 -->
    <reassign ref="reassign" :getInsureList="getInsureList"></reassign>

    <!-- 导出验证 -->
    <export-validation ref="exportValidation" exportUrl="/buz/customerBase/exportCustomer" :requestParam="setRequestParam"></export-validation>
  </div>
</template>

<script>
import {common} from "@/api/mixins";
import selectTree from "./components/selectTree";

import { queryColumns } from "./form/channelColumns";
import importModal from './components/channel/importModal';
import statistics from './components/channel/statistics';
import userPoptip from "@/components/commons/userPoptip";
import policyNumber from './components/policyNumber';
import orderNumber from './components/orderNumber';
import distribution from './components/distribution';
import distributionAbnormal from './components/distributionAbnormal';
import reassign from './components/reassign';
import exportValidation from '@/components/commons/exportValidation';

import { 
  getTabsOne, 
  getTabsTwo, 
  getFollowUpStatusList,
  getOrganizationBase,
} from "./form/api";

export default {
  mixins:[common],
  components: {
    selectTree,
    importModal,
    statistics,
    userPoptip,
    orderNumber,
    policyNumber,
    distribution,
    distributionAbnormal,
    reassign,
    exportValidation
  },
  data() {
    return {
      searchObj: {
        pageNo: 1,
        pageSize: 10,
        isSuccess: '-1',
        type:'-1',
        descs:''
      },
      tabsOneActionIndex:0,
      tabsTwoActiveIndex:0,
      total:null,
      searchMore: false,
      columns: [], //表格列
      tableDate:[],
      organizationList: [],
      followUpStatusList: [],//跟进状态
      salesmanList:[],//所属业务员
      sourceList: [],//客户来源
      tabs: [],
      tabsTwo: [],
      statisticalData:[],//统计数据
    };
  },
  async created() {
    this.columns = await queryColumns(this.tabsOneActionIndex, this.tabsTwoActiveIndex, this);
    this.queryOrganization();
    this.queryTabsOne();
    this.queryTabsTwo();
    this.queryFollowUpStatus();
    this.getSourceList();
    this.getInsureList();
  },
  
  methods: {
    // 机构
    async queryOrganization() {
      const { data } = await getOrganizationBase();
      this.organizationList = this.dealTree([data]);
    },

    // 选中机构/团队
    selectTreeChange(data) {
      if (data.nodeType == 1) {//机构
        this.searchObj.organizationId = data.id;
        this.getOrganizationUser(data.id)
        this.searchObj.groupId = "";
      } else if (data.nodeType == 2) {//团队
        this.searchObj.organizationId = "";
        this.getGroupUser(data.id)
        this.searchObj.groupId = data.id;
      }else{
        this.searchObj.organizationId = "";
        this.searchObj.groupId = "";
      }
    },

    // 通过机构获取业务员
    getOrganizationUser(id) {
      this.$http({
        url: `/buz/userBase/getSubUser?orgId=${id}`,
        type: "GET",
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },

    // 通过机构获取业务员
    getGroupUser(id) {
      this.$http({
        url: `/buz/userBase/getByGroup?groupId=${id}`,
        type: "GET",
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },

    dealTree(arr) {
      return arr.map((item) => ({
        ...item,
        expand: item.nodeType === 1 ? true : false,
        value: item,
        label: item.name,
        children:
          item.children && item.children.length > 0
            ? this.dealTree(item.children)
            : null,
      }));
    },

    // 跟进状态
    async queryFollowUpStatus() {
      const { data } = await getFollowUpStatusList();
      this.followUpStatusList = data.filter(item=>item.value !='-1');
    },

    // 客户来源
    getSourceList(){
      let data = {};
      if(this.tabsTwoActiveIndex==1){
        data.type = '1'
      }else if(this.tabsTwoActiveIndex==2) {
        data.type = '2'
      }else{
        delete data.type
      }
      this.$http({
        url: "/buz/subscribe/querySourceList",
        type: "PUT",
        data
      }).then((res) => {
        this.sourceList = res.data;
      })
    },

    // 获取一级tab
    async queryTabsOne() {
      const { data } = await getTabsOne();
      this.tabs = data;
    },

    // 获取二级tab
    async queryTabsTwo() {
      const { data } = await getTabsTwo();
      this.tabsTwo = data;
    },

    // 处理请求参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchObj));
      if(this.tabsOneActionIndex == 3){
        obj.isDissent = '1';
        delete obj.isSuccess;
        delete obj.type;
      }
      let { ...params } = obj;
      if(this.tabsOneActionIndex==0){
        delete params.isSuccess
      }
      if(this.tabsOneActionIndex==3){
        delete params.isDissent
      }
      if(this.tabsTwoActiveIndex==0){
        delete params.type
      }
      return params;
    },

    // 详情
    toDetail(row) {
      this.$router.push({
        path:"/customerManage/channelDetail",
        query:{
          id:row.id,
          agentId:row.agentId,
        }
      })
    },

    // 获取统计
    getStatisticsData() {
      this.$http({
        url: "/buz/customerBase/statistics",
        type: "POST",
        data: this.setRequestParam(),
      }).then((res) => {
        this.statisticalData = res.data;
      })
    },

    // 获取列表
    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/customerBase/read/list",
        type: "POST",
        data: this.setRequestParam(),
      }).then((res) => {
        this.getStatisticsData();
        this.$root.$children[0].isShowLoading = false;
        this.tableDate = res.data.map(item=>{
          return {
            ...item,
            focusProductName:item.focusProductName?item.focusProductName:'-'
          }
        });
        this.total = res.total;
      }).catch(() => {
        this.$root.$children[0].isShowLoading = false;
      });        
    },

    // 获取异议客户列表
    getObjectionList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/customerBase/read/abnormal/list",
        type: "POST",
        data: this.setRequestParam(),
      }).then((res) => {
        this.$root.$children[0].isShowLoading = false;
        this.tableDate = res.data;
        this.total = res.total;
      }).catch(() => {
        this.$root.$children[0].isShowLoading = false;
      });    
    },

    // 搜索
    queryList() {
      this.searchObj.pageNo = 1;
      if(this.tabsOneActionIndex!=3){
        this.getInsureList();
      }else{
        delete this.searchObj.descs;
        this.getObjectionList();
      }
    },

    // 重置
    async resetSearch() {
      this.columns = [];
      this.searchObj = {
        pageNo: 1,
        pageSize: 10,
        isSuccess: '-1',
        type:'-1',
        descs:'t.create_time',
        organizationId:'',
        groupId:''
      };
      this.$refs.selectTree.clear();
      
      this.tabsOneActionIndex = 0;
      this.tabsTwoActiveIndex = 0;      
      this.columns = await queryColumns(this.tabsOneActionIndex, this.tabsTwoActiveIndex, this);
      
      
      if(this.tabsOneActionIndex!=3){
        this.getInsureList();
      }else{
        delete this.searchObj.descs;
        this.getObjectionList();
      }
    },

    // 切换tab更新时间排序
    updateTableTimeSortVal(){
      if(this.tabsOneActionIndex==0&&this.tabsTwoActiveIndex==0){
        this.searchObj.descs = 't1.chat_date';
      }else if(this.tabsOneActionIndex==0&&this.tabsTwoActiveIndex==1) {
        this.searchObj.descs = 't2.last_subscribe_date';
      }else if(this.tabsOneActionIndex==0&&this.tabsTwoActiveIndex==2) {
        this.searchObj.descs = 't1.chat_date';
      }else if(this.tabsOneActionIndex==1&&this.tabsTwoActiveIndex==0) {
        this.searchObj.descs = 't1.chat_date';
      }else if(this.tabsOneActionIndex==1&&this.tabsTwoActiveIndex==1) {
        this.searchObj.descs = 't2.last_subscribe_date';
      }else if(this.tabsOneActionIndex==1&&this.tabsTwoActiveIndex==2) {
        this.searchObj.descs = 't1.chat_date';
      }else if(this.tabsOneActionIndex==2&&this.tabsTwoActiveIndex==0) {
        this.searchObj.descs = 't.success_time';
      }else if(this.tabsOneActionIndex==2&&this.tabsTwoActiveIndex==1) {
        this.searchObj.descs = 't2.last_subscribe_date';
      }else if(this.tabsOneActionIndex==2&&this.tabsTwoActiveIndex==2) {
        this.searchObj.descs = 't1.chat_date';
      }
    },

    //切换一级tab
    changeTabsOne(value, index) {
      this.searchObj.isSuccess = value;
      this.columns = [];
      this.tabsOneActionIndex = index;
      this.tabsTwoActiveIndex = 0;
      this.searchObj.type = '-1';
      this.searchObj.pageNo = 1;
      this.updateTableTimeSortVal();

      setTimeout(() => {
        if(index == 0){
          this.columns = queryColumns(this.tabsOneActionIndex, this.tabsTwoActiveIndex, this);
        }else if(index == 1) {
          this.columns = queryColumns(this.tabsOneActionIndex, this.tabsTwoActiveIndex, this);
        }else {
          this.columns = queryColumns(this.tabsOneActionIndex, this.tabsTwoActiveIndex, this);
        }
      }, 100);      
      
      if(this.tabsOneActionIndex!=3){
        this.getInsureList();
      }else{
        this.searchObj.descs = 't.create_time';
        this.getObjectionList();
      }
    },

    // 切换二级tab
    changeTabsTwo(value, index) {
      this.$root.$children[0].isShowLoading = true;
      this.columns = [];
      this.searchObj.type = value;
      this.tabsTwoActiveIndex = index;
      this.searchObj.pageNo = 1;
      this.updateTableTimeSortVal();

      setTimeout(() => {
        if(index == 0){
          this.columns = queryColumns(this.tabsOneActionIndex, this.tabsTwoActiveIndex, this);
        }else if(index == 1) {
          this.columns = queryColumns(this.tabsOneActionIndex, this.tabsTwoActiveIndex, this);
        }else {
          this.columns = queryColumns(this.tabsOneActionIndex, this.tabsTwoActiveIndex, this);
        }
        this.$root.$children[0].isShowLoading = false;
      }, 100);

      this.getInsureList();
      this.getSourceList();
    },

    // 组织架构
    toOrgManage(row, type) {
      // type 1:机构 、 2：团队
      this.$router.push({
        path:"/orgManage/index",
        query:{
          groupId:row.groupId,
          organizationId:row.organizationId,
          type
        }
      })
    },

    openEye(row) {
      if(!row.eyeShow){
        this.descrypt({
          query:row.id,
          operationFunction:6,
          operationType:2,
        },row, 'mobile').then(()=>{
          this.$set(row,'eyeShow',true);
        })
      }else{
        this.$set(row,'eyeShow',false);
      }
    },

    // 分页
    pageChange(pageNo) {
      this.searchObj.pageNo = pageNo;
      if(this.tabsOneActionIndex!=3){
        this.getInsureList();
      }else{
        this.getObjectionList();
      }      
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./channel.scss";
</style>